import { navigate } from '@reach/router'

import { ROUTES } from '_utils/constants'

export function navigateToExpiredLink() {
  navigate(ROUTES.LINK_EXPIRED, { replace: true })
}

export const EXPIRED_LINK_REDIRECT_PROPS = {
  to: ROUTES.LINK_EXPIRED,
  replace: true,
  noThrow: true,
}
